import deepEqual from "deep-equal";
import jsPDF from "jspdf";
import moment from "moment";
import {ROOT_URL} from "../../webapp-commons/config";

export const objectIdToDate = function(value) {
  return new Date(parseInt(value.substring(0, 8), 16) * 1000);
};

const wrapRefresh = async call => {
  const result = await call();
  if (!result.ok) {
    const msg = (await result.clone().json()).message;
    console.log(msg);
    if (msg === "Invalid credentials") {
      const token = localStorage.getItem("hil_token");
      if (token != null) {
        await localStorage.removeItem("hil_token");
        window.location.href = "/";
      }
    }
    if (msg === "Expired token") {
      const headers = new Headers();
      const token = localStorage.getItem("hil_token");
      if (token != null) {
        headers.append("Authorization", token);
      }
      const resp = await fetch(`${process.env.VUE_APP_BASEURL}/refresh`, {
        method: "POST",
        headers
      });
      if (!resp.ok) {
        await localStorage.removeItem("hil_token");
        window.location.href = "/";
      }
      const newToken = (await resp.json()).token;
      await localStorage.setItem("hil_token", newToken);
      return await call();
    }
  }
  return result;
};

export const fetchHil = (url, options) => {
  const headers = headers || new Headers();
  if (
    options &&
    typeof options.body === "object" &&
    !(options.body instanceof FormData)
  ) {
    headers.set("Content-Type", "application/json");
    options.body = JSON.stringify(options.body);
  }

  return wrapRefresh(() => {
    const token = localStorage.getItem("hil_token");
    if (token != null) {
      headers.set("Authorization", token);
    }

    return fetch(process.env.VUE_APP_BASEURL + url, {
      ...options,
      headers
    });
  });
};

export const fetchHil2 = async (method, url, options) => {
  const headers = headers || new Headers();
  if (
    options &&
    typeof options.body === "object" &&
    !(options.body instanceof FormData)
  ) {
    headers.set("Content-Type", "application/json");
    options.body = JSON.stringify(options.body);
  }

  const resp = await wrapRefresh(() => {
    const token = localStorage.getItem("hil_token");
    if (token != null) {
      headers.set("Authorization", token);
    }
    return fetch(process.env.VUE_APP_BASEURL + url, {
      ...options,
      headers,
      method
    });
  });

  if (resp.status === 204) {
    return;
  }
  return await resp.json();
};

function splitString(string, divider) {
  if (!string) {
    return "";
  }
  const fullString = string.split("<br>");
  fullString[0] = fullString[0].trim().replace(/\r?\n|\r/g, "");
  fullString[0] = fullString[0]
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
  const regDivide = new RegExp(".{" + divider + "}\\S*\\s+", "g");
  const array_string = fullString[0].replace(regDivide, "$&@").split(/\s+@/);
  fullString[0] = array_string.join("<br>");
  return fullString[0];
}

export const exportPdfVisites = async (proposals, projectId, userId) => {
  const sorted = [...proposals.filter(({ visited }) => visited != null)];
  sorted.sort((a, b) => {
    let adv = moment(a.visited.dateVisite);
    let bdv = moment(b.visited.dateVisite);
    return adv.diff(bdv);
  });
  const doc = new jsPDF("l", "pt", "a4");
  const widthImg = 100;
  //const heightImg = widthImg / 248 * 145;
  const now = new Date();
  //doc.addImage(this.logoDataUri, 'png', 25, 25, widthImg, heightImg);
  doc.setFont("helvetica");
  doc.setFontType("bold");
  doc.text(`Projet de relocation n° ${projectId}`, 210, 100);
  doc.text(`(${userId})`, 380, 120);
  let html =
    "<html>" +
    "<body>" +
    "<h2>Liste des visites</h2>" +
    "<p>En cas de besoin n'hésitez pas à nous contacter au +33 7 67 38 23 68</p>" +
    "<table style='font-size:8px;'>" +
    "<thead>" +
    "<tr>" +
    "<th>N° bien</th>" +
    "<th>Date visite</th>" +
    "<th>Heure visite</th>" +
    "<th>Adresse</th>" +
    "<th>Surface</th>" +
    "<th>Prix</th>" +
    "<th>Pièces</th>" +
    "<th>Contact</th>" +
    "<th>Tel contact</th>" +
    "</tr>" +
    "</thead>" +
    "<tbody>";
  let i = 1;
  for (const visited of sorted) {
    const host = visited._host;
    if (
      (!visited.cancel || visited.cancel === false) &&
      (!visited.cancelClient || visited.cancelClient === false) &&
      host.isActive &&
      host.publish
    ) {
      html =
        html +
        "<tr style='background-color: #ff80aa'>" +
        "<td>" +
        i +
        "</td>" +
        "<td>" +
        moment(visited.visited.dateVisite).format("DD/MM/YYYY") +
        "</td>" +
        "<td>" +
        moment(visited.visited.dateVisite).format("HH:mm") +
        "</td>" +
        "<td>" +
        host.address +
        "</td>" +
        "<td>" +
        host.carrez +
        "</td>" +
        "<td>" +
        host.price +
        "</td>" +
        "<td>" +
        host.numberOfRoom +
        "</td>" +
        "<td>" +
        host.contactName +
        "</td>" +
        "<td>" +
        host.contactPhoneNumber +
        "</td>" +
        "</tr>";
      i++;
    }
  }
  html = html + "</tbody>" + "</table>" + "</body>" + "</html>";
  doc.fromHTML(html, 75, 150);
  doc.addPage();
  html = "<html>" + "<body>" + "<h2>Descriptions des biens</h2>" + "<br>";
  i = 0;
  for (const visited of sorted) {
    const host = visited._host;
    if (
      (!visited.cancel || visited.cancel === false) &&
      (!visited.cancelClient || visited.cancelClient === false) &&
      host.isActive &&
      host.publish
    ) {
      i++;
      const address = `${ROOT_URL}/leases/project/${projectId}/search/${visited.id}`;
      html =
        html +
        "<p><strong>" +
        i +
        "</strong>. " +
        splitString(host.description, 120) +
        "<br><strong>Lien bien</strong> : <a href=''>" +
        address +
        "</a></p>";
      if (i % 5 == 0) {
        html = html + "</body>" + "</html>";
        doc.fromHTML(html.replace(/[\u0100-\uFFFF]/g, ""), 25, 25);
        doc.addPage();
        html =
          "<html>" +
          "<body>" +
          "<h2>Descriptions des biens (suite)</h2>" +
          "<br>";
      }
    }
  }
  html = html + "</body>" + "</html>";
  doc.fromHTML(html.replace(/[\u0100-\uFFFF]/g, ""), 25, 25);
  const filename = `programmation_visite_${userId.split("@")[0]}.pdf`;
  doc.save(filename);
};

export const exportPDFProposals = async (proposals, project) => {
  const doc = new jsPDF("p", "pt", "a4");
  const widthImg = 100;
  //const heightImg = widthImg / 248 * 145;
  //doc.addImage(this.logoDataUri, 'png', 25, 25, widthImg, heightImg);
  doc.setFont("helvetica");
  doc.setFontType("bold");
  let html =
    "<html>" +
    "<body>" +
    "<h2>Liste des biens aimés</h2>" +
    "<table style='font-size:8px;'>" +
    "<thead>" +
    "<tr>" +
    "<th>N° bien</th>" +
    "<th>Adresse</th>" +
    "<th>Surface</th>" +
    "<th>Prix</th>" +
    "<th>Pièces</th>" +
    "<th>Contact</th>" +
    "<th>Tel contact</th>" +
    "</tr>" +
    "</thead>" +
    "<tbody>";
  let i = 1;
  for (const prop of proposals) {
    const host = prop._host;
    if (host.isActive && host.publish) {
      html =
        html +
        "<tr>" +
        "<td>" +
        i +
        "</td>" +
        "<td>" +
        host.address +
        "</td>" +
        "<td>" +
        host.carrez +
        "</td>" +
        "<td>" +
        host.price +
        "</td>" +
        "<td>" +
        host.numberOfRoom +
        "</td>" +
        "<td>" +
        host.contactName +
        "</td>" +
        "<td>" +
        host.contactPhoneNumber +
        "</td>" +
        "</tr>";
      i++;
    }
  }
  html = html + "</tbody>" + "</table>" + "</body>" + "</html>";
  doc.fromHTML(html, 75, 100);
  doc.addPage();
  html = "<html>" + "<body>" + "<h2>Projet du client</h2>" + "<br>";
  if (project.aboutYou || project.aboutYouAdmin) {
    html = html + "<h4>A propos du client : </h4>";
    if (project.aboutYou) {
      html = `${html}<p>${splitString(project.aboutYou, 100)}</p>`;
    }
    if (project.aboutYouAdmin) {
      html = `${html}<p>${splitString(project.aboutYouAdmin, 100)}</p>`;
    }
  }
  if (project.descEstate || project.descEstateAdmin) {
    html = html + "<h4>A propos du client : </h4>";
    if (project.descEstate) {
      html = `${html}<p>${splitString(project.descEstate, 100)}</p>`;
    }
    if (project.descEstateAdmin) {
      html = `${html}<p>${splitString(project.descEstateAdmin, 100)}</p>`;
    }
  }
  if (project.futurNeighborhood || project.futurNeighborhoodAdmin) {
    html = html + "<h4>A propos du client : </h4>";
    if (project.futurNeighborhood) {
      html = `${html}<p>${splitString(project.futurNeighborhood, 100)}</p>`;
    }
    if (project.futurNeighborhoodAdmin) {
      html = `${html}<p>${splitString(
        project.futurNeighborhoodAdmin,
        100
      )}</p>`;
    }
  }
  html = html + "</body>" + "</html>";
  doc.fromHTML(html.replace(/[\u0100-\uFFFF]/g, ""), 25, 25);
  const filename = "liste_bien_" + project.userId.split("@")[0] + ".pdf";
  doc.save(filename);
};

export const clean = obj => {
  if (obj === undefined) {
    return obj;
  }
  return JSON.parse(JSON.stringify(obj));
};

export const getDiff = (orig, upd, booleanCheck = false) => {
  const diff = {};

  if ((orig == null && upd != null) || (upd == null && orig != null)) {
    diff["all"] = true;
    return booleanCheck ? true : diff;
  }

  if (orig == null && upd == null) {
    return booleanCheck ? false : {};
  }

  for (const k of Object.keys(upd)) {
    const origValue = orig[k];
    const value = upd[k];

    if (origValue === undefined && value !== undefined) {
      if (booleanCheck) {
        return true;
      }
      diff[k] = value;
    } else if (!deepEqual(clean(origValue), clean(value))) {
      if (booleanCheck) {
        return true;
      }
      diff[k] = value;
    }
  }

  return booleanCheck ? false : diff;
};

export const likedOrDisliked = item => {
  if (
    item.liked != null &&
    (item.disliked == null || moment(item.liked) > moment(item.disliked))
  ) {
    return 1;
  } else if (
    item.disliked != null &&
    (item.liked == null || moment(item.disliked) > moment(item.liked))
  ) {
    return 2;
  } else {
    return 3;
  }
};

export const sortPositions = (chosen, index, isDesc) => {
  return (a, b) => {
    if (index === "position") {
      if (chosen === a.idSell) {
        return isDesc ? 1 : -1;
      } else if (chosen === b.idSell) {
        return isDesc ? -1 : 1;
      } else if (a.position > b.position) {
        return isDesc ? -1 : 1;
      } else if (b.position > a.position) {
        return isDesc ? 1 : -1;
      } else {
        return likedOrDisliked(a) > likedOrDisliked(b)
          ? isDesc
            ? -1
            : 1
          : isDesc
          ? 1
          : -1;
      }
    } else {
      if (!isDesc) {
        return a[index] < b[index] ? -1 : 1;
      } else {
        return b[index] < a[index] ? -1 : 1;
      }
    }
  };
};

export const checkFormLine = (ruleLine, data, project) => {
  if (ruleLine) {
    const t = typeof ruleLine;
    let rulesObj = ruleLine;
    if (t === "string") {
      rulesObj = {};
      const rules = ruleLine.split("|");
      for (const r of rules) {
        const [name, value] = r.split(":");
        rulesObj[name] = value || true;
      }
    } else if (t === "object") {
      // Nothing to do
    } else {
      throw new TypeError(`Unexpected ruleLine of type ${t}`);
    }

    if (
      !rulesObj.required &&
      !rulesObj.required_if &&
      (data == null || data === "")
    ) {
      // Special case for required, there's no need to continue if we don't have a value
      return true;
    }

    for (const [name, value] of Object.entries(rulesObj)) {
      switch (name) {
        case "required":
          if (value && (data == null || data === "")) {
            return false;
          }
          break;
        case "required_if": {
          const [target, targetedValue] = value.split(",");
          const isRequired = `${project[target]}` === targetedValue;
          const isEmpty = data == null || data === "";
          if (isRequired) {
            if (isEmpty) {
              return false;
            }
          } else {
            if (isEmpty) {
              return true;
            }
          }
          break;
        }
        case "min_value":
          if (+data < +value) {
            return false;
          }
          break;
        case "precise":
          if (project[value] == null) {
            return false;
          }
          break;
        case "date":
          if (!(data instanceof Date || !isNaN(new Date(data)))) {
            return false;
          }
          break;
        case "regex": {
          const regex = typeof value === "string" ? new RegExp(value) : value;
          if (!regex.test(data)) {
            return false;
          }
          break;
        }
      }
    }
  }

  return true;
};
